import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ZagIcon } from '../icon/icon';

/**
 * Reusable loading state component with spinner and message.
 *
 * @example
 * ```html
 * <zag-loading-state [message]="'common.loading' | translate" />
 * ```
 */
@Component({
  selector: 'zag-loading-state',
  imports: [ZagIcon],
  template: `
    <div class="loading-state">
      <span zagIcon="sync" class="loading-state__spinner spinning"></span>
      <p class="loading-state__message">{{ message() }}</p>
    </div>
  `,
  styleUrl: './loading-state.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingStateComponent {
  /**
   * Loading message to display below spinner.
   * @default 'Loading...'
   */
  readonly message = input<string>('Loading...');
}
